import { IoBusiness } from "react-icons/io5";
import { MdOutlineDocumentScanner } from "react-icons/md";

export const BreadcrumbItems = [
  {
    title: (
      <>
        <IoBusiness />
        <span>Empresas</span>
      </>
    ),
    href: "/app/audits",
    className: "flex items-center justify-around gap-2 p-1",
  },
  {
    title: (
      <>
        <MdOutlineDocumentScanner />
        <span>Diagnóstico</span>
      </>
    ),
    className: "flex items-center justify-around gap-2",
  },
];
